export default __webpack_public_path__ + "static/media/mepExpand2.b8746afd.jpg";